import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  speed: 500,
  dots: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: true,
  infinite: false,
  responsive: [{
    breakpoint: 1366,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  }, {
    breakpoint: 1200,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      // variableWidth: false,
    },
  }, {
    breakpoint: 640,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      // centerPadding: '15px',
      // variableWidth: true,
    },
  }],
};

function NewNews(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.build();
  this.ready();
}

NewNews.prototype = {
  build() {
    return this.$element.find('.node-image').slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default NewNews;
